import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { faqCategoriesApi, faqQuestionsApi } from '../../services/webApi';

const SikcaSorulanSorular = () => {
  const [faqCategories, setFaqCategories] = useState([]);
  const [faqQuestions, setFaqQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    // Initialize Lucide Icons
    const initLucide = () => {
      if (window.lucide && window.lucide.createIcons) {
        window.lucide.createIcons();
      }
    };

    // Fetch FAQ data from API
    const fetchFaqData = async () => {
      try {
        // Categories'i önce çek
        const categoriesResponse = await faqCategoriesApi.getAll();
        if (isMounted && categoriesResponse.data.success) {
          setFaqCategories(categoriesResponse.data.data);
        } else if (isMounted) {
          console.log('Categories API failed, using fallback');
        }

        // Sonra questions'i çek
        const questionsResponse = await faqQuestionsApi.getAll();
        if (isMounted && questionsResponse.data.success) {
          setFaqQuestions(questionsResponse.data.data);
        } else if (isMounted) {
          console.log('Questions API failed, using fallback');
        }

        // Eğer her ikisi de başarısızsa fallback data kullan
        if (isMounted && (!categoriesResponse.data.success || !questionsResponse.data.success)) {
          console.log('Using fallback FAQ data');
          setFaqCategories([
            {
              id: 1,
              title: 'Genel Sorular',
              icon: 'help-circle',
              is_active: true,
              sort_order: 1
            },
            {
              id: 2,
              title: 'Teknik Özellikler',
              icon: 'settings',
              is_active: true,
              sort_order: 2
            },
            {
              id: 3,
              title: 'Faturalama ve Ödeme',
              icon: 'credit-card',
              is_active: true,
              sort_order: 3
            },
            {
              id: 4,
              title: 'Entegrasyonlar',
              icon: 'link',
              is_active: true,
              sort_order: 4
            },
            {
              id: 5,
              title: 'Destek ve Lisanslama',
              icon: 'headphones',
              is_active: true,
              sort_order: 5
            }
          ]);
          setFaqQuestions([
            {
              id: 1,
              category_id: 1,
              question: 'ISP Radius nedir?',
              answer: 'ISP Radius, internet servis sağlayıcıları için özel olarak geliştirilmiş kapsamlı bir yönetim sistemidir. Abone yönetimi, faturalama, ödeme takibi, BTK loglama ve daha birçok özellik sunar.',
              is_active: true,
              sort_order: 1
            },
            {
              id: 2,
              category_id: 1,
              question: 'Hangi işletmeler ISP Radius kullanabilir?',
              answer: 'ISP Radius, internet servis sağlayıcıları, telekomünikasyon şirketleri, hosting firmaları ve benzeri işletmeler tarafından kullanılabilir. Küçük işletmelerden büyük operatörlere kadar her ölçekteki şirket için uygundur.',
              is_active: true,
              sort_order: 2
            },
            {
              id: 3,
              category_id: 1,
              question: 'Sistem kurulumu ne kadar sürer?',
              answer: 'Sistem kurulumu genellikle 1-3 iş günü arasında tamamlanır. Kurulum süresi, mevcut sistemlerinizle entegrasyon gereksinimlerinize bağlı olarak değişebilir.',
              is_active: true,
              sort_order: 3
            },
            {
              id: 4,
              category_id: 1,
              question: 'Teknik destek hizmeti var mı?',
              answer: 'Evet, 7/24 teknik destek hizmetimiz bulunmaktadır. Uzman ekibimiz herhangi bir sorun yaşadığınızda anında çözüm bulmanızda yardımcı olur.',
              is_active: true,
              sort_order: 4
            },
            {
              id: 5,
              category_id: 2,
              question: 'BTK loglama sistemi nasıl çalışır?',
              answer: 'BTK loglama sistemi, Bilgi Teknolojileri ve İletişim Kurumu gereksinimlerine uygun olarak otomatik loglama yapar. Abone, abone rehber, abone hareket, NAT (IPDR), oturum ve AIH loglamalarını gerçekleştirir.',
              is_active: true,
              sort_order: 1
            },
            {
              id: 6,
              category_id: 2,
              question: 'Mikrotik entegrasyonu nasıl yapılır?',
              answer: 'Mikrotik cihazlarınızı ISP Radius ile entegre ederek uzaktan yönetim, konfigürasyon güncellemeleri, performans izleme ve kullanıcı yönetimi yapabilirsiniz. CGNat, Netmap ve Load Balancing özellikleri de desteklenir.',
              is_active: true,
              sort_order: 2
            },
            {
              id: 7,
              category_id: 2,
              question: 'Türk Telekom entegrasyonu hangi işlemleri kapsar?',
              answer: 'Türk Telekom entegrasyonu yeni tesis, churn, tarife değişikliği, nakil, dönüşüm, başvuru durum sorgulama, DTS fatura analizi, arıza yönetimi ve alt yapı sorgulama işlemlerini kapsar.',
              is_active: true,
              sort_order: 3
            },
            {
              id: 8,
              category_id: 2,
              question: 'Sistem güvenliği nasıl sağlanıyor?',
              answer: 'Sistemimiz SSL şifreleme, güvenli API erişimi, veri yedekleme ve erişim kontrolü ile korunmaktadır. Tüm verileriniz güvenli sunucularda saklanır ve düzenli olarak yedeklenir.',
              is_active: true,
              sort_order: 4
            },
            {
              id: 9,
              category_id: 3,
              question: 'Faturalama sistemi nasıl çalışır?',
              answer: 'Otomatik faturalama sistemi ile abonelerinizin faturalarını otomatik olarak oluşturabilir, gönderebilir ve takip edebilirsiniz. Farklı paket türleri ve tarife seçenekleri desteklenir.',
              is_active: true,
              sort_order: 1
            },
            {
              id: 10,
              category_id: 3,
              question: 'Hangi ödeme yöntemleri destekleniyor?',
              answer: 'Kredi kartı, banka transferi, mobil ödeme ve otomatik tahsilat sistemleri desteklenir. Ayrıca kurum tahsilatları için özel entegrasyonlar mevcuttur.',
              is_active: true,
              sort_order: 2
            },
            {
              id: 11,
              category_id: 3,
              question: 'Ödeme takibi nasıl yapılır?',
              answer: 'Ödeme geçmişi, vadesi geçen faturalar, ödeme bildirimleri ve detaylı raporlama ile ödemelerinizi kolayca takip edebilirsiniz.',
              is_active: true,
              sort_order: 3
            },
            {
              id: 12,
              category_id: 3,
              question: 'Fatura şablonları özelleştirilebilir mi?',
              answer: 'Evet, firmanızın kurumsal kimliğine uygun fatura şablonları oluşturabilir ve özelleştirebilirsiniz.',
              is_active: true,
              sort_order: 4
            },
            {
              id: 13,
              category_id: 4,
              question: 'Hangi SMS servisleri destekleniyor?',
              answer: 'Sanal Santral, Netgsm, Verimor, Öztek SMS ve E Telekom gibi SMS servisleri ile entegrasyon mevcuttur.',
              is_active: true,
              sort_order: 1
            },
            {
              id: 14,
              category_id: 4,
              question: 'Sanal POS entegrasyonları hangileri?',
              answer: 'N Kolay, Türkiye İş Bankası, Türkiye Vakıflar Bankası ve Paytr gibi sanal POS sistemleri desteklenir.',
              is_active: true,
              sort_order: 2
            },
            {
              id: 15,
              category_id: 4,
              question: 'E-fatura entegrasyonu nasıl yapılır?',
              answer: 'Hızlı Bilişim Teknolojileri ve QNB eSolutions gibi e-fatura sağlayıcıları ile entegrasyon yapılabilir.',
              is_active: true,
              sort_order: 3
            },
            {
              id: 16,
              category_id: 4,
              question: 'Muhasebe yazılımları ile entegrasyon var mı?',
              answer: 'Paraşüt, Mikro Yazılım ve BAY.t Yazılım gibi muhasebe sistemleri ile entegrasyon mevcuttur.',
              is_active: true,
              sort_order: 4
            },
            {
              id: 17,
              category_id: 5,
              question: 'Lisanslama modeli nasıl çalışır?',
              answer: 'ISP Radius, abone sayısına göre lisanslanır. Esnek lisanslama seçenekleri ile işletmenizin büyüklüğüne uygun paket seçebilirsiniz.',
              is_active: true,
              sort_order: 1
            },
            {
              id: 18,
              category_id: 5,
              question: 'Eğitim hizmeti veriliyor mu?',
              answer: 'Evet, sistem kullanımı için detaylı eğitim materyalleri ve canlı eğitim seansları sunuyoruz.',
              is_active: true,
              sort_order: 2
            },
            {
              id: 19,
              category_id: 5,
              question: 'Sistem güncellemeleri nasıl yapılır?',
              answer: 'Sistem güncellemeleri otomatik olarak yapılır ve kullanıcılarınızı etkilemez. Önemli güncellemeler önceden bildirilir.',
              is_active: true,
              sort_order: 3
            },
            {
              id: 20,
              category_id: 5,
              question: 'Veri yedekleme nasıl yapılıyor?',
              answer: 'Tüm verileriniz günlük olarak yedeklenir ve güvenli sunucularda saklanır. Acil durumlarda hızlı veri kurtarma hizmeti sunulur.',
              is_active: true,
              sort_order: 4
            }
          ]);
        }
      } catch (err) {
        console.error('FAQ data fetch error:', err);
        if (isMounted) {
          setError('Veriler yüklenirken hata oluştu');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    // Hemen başlat
    fetchFaqData();

    // Initialize icons after data is loaded
    const iconTimer = setTimeout(() => {
      initLucide();
    }, 100);

    return () => {
      isMounted = false;
      clearTimeout(iconTimer);
    };
  }, []);

  // Helper function to get questions for a category
  const getQuestionsForCategory = (categoryId) => {
    // categoryId string olarak gelebilir, number'a çevir
    const catId = typeof categoryId === 'string' ? parseInt(categoryId) : categoryId;
    return faqQuestions.filter(question => {
      const qCatId = typeof question.category_id === 'string' ? parseInt(question.category_id) : question.category_id;
      return qCatId === catId;
    });
  };

  // Initialize icons when data changes and periodically refresh
  useEffect(() => {
    const initIcons = () => {
      if (window.lucide && window.lucide.createIcons) {
        try {
          window.lucide.createIcons();
        } catch (error) {
          console.error('Error creating icons:', error);
        }
      }
    };

    if (!loading && !error) {
      // Initial setup
      setTimeout(initIcons, 100);
      
      // Also re-init periodically to catch any missed icons
      const interval = setInterval(initIcons, 500);
      
      return () => clearInterval(interval);
    }
  }, [loading, error, faqCategories.length, faqQuestions.length]);


  return (
    <>
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-[72px] backdrop-blur-3xl">
        <div className="overlay"></div>
        <div className="stars" aria-hidden="true"></div>
        <div className="starts2" aria-hidden="true"></div>
        <div className="stars3" aria-hidden="true"></div>

        <div className="px-6 pt-20 overflow-hidden">
          <div className="container">
            <div className="py-14 text-center relative">
              <div className="flex justify-center">
                <div className="max-w-2xl">
                  <h2 className="md:text-6xl/tight text-5xl text-default-100 font-semibold mb-6">
                    <span className="bg-gradient-to-l from-rose-500 to-primary text-transparent bg-clip-text">Sıkça Sorulan Sorular</span>
                    <br />Merak Ettikleriniz
                  </h2>
                  <p className="text-sm font-medium text-default-400 mt-5">
                    ISP Radius hakkında en çok merak edilen sorular ve cevapları burada bulabilirsiniz.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Categories - Modern Design */}
      <section className="py-14">
        <div className="container">
          {loading ? (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              <p className="text-default-400 mt-4">SSS verileri yükleniyor...</p>
            </div>
          ) : error ? (
            <div className="text-center py-8">
              <p className="text-red-500">{error}</p>
            </div>
          ) : faqQuestions.length > 0 ? (
            <div className="grid lg:grid-cols-2 gap-6">
              <div className="hs-accordion-group space-y-4" data-aos="fade-right" data-aos-easing="ease" data-aos-duration="1000">
                {faqQuestions.slice(0, Math.ceil(faqQuestions.length / 2)).map((faq, index) => (
                  <div key={faq.id} className="hs-accordion border border-white/10 bg-default-950/40 backdrop-blur-3xl rounded-lg overflow-hidden" id={`faq-${faq.id}`}>
                    <button className="hs-accordion-toggle capitalize px-6 py-4 inline-flex items-center justify-between gap-x-3 w-full text-left text-white transition-all" aria-controls={`faq-${faq.id}`}>
                      <h5 className="text-base font-semibold flex">
                        <i data-lucide="help-circle" className="h-5 w-5 stroke-white me-3"></i>
                        {faq.question}
                      </h5>
                      <i data-lucide="chevron-up" className="h-4 w-4 transition-all duration-500 hs-accordion-active:-rotate-180"></i>
                    </button>
                    <div id={`faq-${faq.id}`} className="hs-accordion-content hidden w-full overflow-hidden transition-[height] duration-300" aria-labelledby={`faq-${faq.id}`}>
                      <div className="px-6 pb-4 pt-0">
                        <p className="text-default-300 text-sm font-medium mb-2">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="hs-accordion-group space-y-4" data-aos="fade-left" data-aos-easing="ease" data-aos-duration="1000">
                {faqQuestions.slice(Math.ceil(faqQuestions.length / 2)).map((faq, index) => (
                  <div key={faq.id} className="hs-accordion border border-white/10 bg-default-950/40 backdrop-blur-3xl rounded-lg overflow-hidden" id={`faq-${faq.id}`}>
                    <button className="hs-accordion-toggle capitalize px-6 py-4 inline-flex items-center justify-between gap-x-3 w-full text-left text-white transition-all" aria-controls={`faq-${faq.id}`}>
                      <h5 className="text-base font-semibold flex">
                        <i data-lucide="help-circle" className="h-5 w-5 stroke-white me-3"></i>
                        {faq.question}
                      </h5>
                      <i data-lucide="chevron-up" className="h-4 w-4 transition-all duration-500 hs-accordion-active:-rotate-180"></i>
                    </button>
                    <div id={`faq-${faq.id}`} className="hs-accordion-content hidden w-full overflow-hidden transition-[height] duration-300" aria-labelledby={`faq-${faq.id}`}>
                      <div className="px-6 pb-4 pt-0">
                        <p className="text-default-300 text-sm font-medium mb-2">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="text-center py-8">
              <p className="text-default-400">Henüz SSS verisi bulunmuyor.</p>
            </div>
          )}
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-14">
        <div className="container">
          <div className="bg-default-950/40 backdrop-blur-3xl rounded-xl p-8 text-center">
            <div className="inline-flex items-center justify-center h-16 w-16 bg-primary/10 text-primary rounded-xl mb-10 mx-auto">
              <i data-lucide="message-circle" className="h-10 w-10"></i>
            </div>
            <h2 className="text-2xl text-white font-medium mb-4">Sorunuz Burada Yok mu?</h2>
            <p className="text-base text-default-200 mb-6 max-w-2xl mx-auto">
              Aradığınız cevabı bulamadıysanız, uzman ekibimizle iletişime geçin. Size en kısa sürede yardımcı olacağız.
            </p>
            <Link 
              to="/iletisim" 
              className="inline-flex items-center justify-center gap-2 bg-primary text-white py-2 px-6 rounded-full hover:bg-primary-hover transition-all duration-300"
            >
              İletişime Geç
              <i data-lucide="arrow-right" className="h-5 w-5"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default SikcaSorulanSorular;
